import { render, staticRenderFns } from "./StoredCardTabs.vue?vue&type=template&id=55a6fe45&"
import script from "./StoredCardTabs.vue?vue&type=script&lang=js&"
export * from "./StoredCardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports